import script from "./SnippetsConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SnippetsConfirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./SnippetsConfirmDialog.vue?vue&type=style&index=0&id=8075324e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8075324e"]])

export default __exports__